<template>
  <icon-base
    v-if="expanded"
    height="21"
    width="21"
    icon="shrink"
    icon-color="none"
    icon-name="Shrink"
  />
  <icon-base
    v-else
    height="21"
    width="21"
    icon="expand"
    icon-color="none"
    icon-name="Expand"
  />
</template>
<script type="text/javascript">
export default {
  name: "ExpandButton",
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
